const ANIMATION_FUNCTION = 'cubic-bezier(0.14, 1.12, 0.67, 0.99)';
const DEFAULT_ANIMATION_DURATION = '0.3s';
function normalizeTransitionProps(transition) {
    return typeof transition === 'string'
        ? {
            name: transition,
            duration: DEFAULT_ANIMATION_DURATION,
        }
        : Object.assign(Object.assign({}, transition), { duration: transition.duration || DEFAULT_ANIMATION_DURATION });
}
function createTransitionForProperty(transition) {
    const { name, duration, delay } = normalizeTransitionProps(transition);
    return [name, duration, ANIMATION_FUNCTION, delay].filter(Boolean).join(' ');
}
export function createElectricTransition(...transitions) {
    if (transitions.length === 0) {
        return;
    }
    return `transition: ${transitions
        .map(createTransitionForProperty)
        .join(', ')}`;
}
